import { contenuPromoMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [contenuPromoMock];

export const promoMock: SlugPage = {
  ...pageBase({
    title: 'Promo',
    type: 'undefined',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
